<template>
  <div v-bind:class="{ paddingContent: isSidebarShow, nonPaddingContent: !isSidebarShow }">
    <div class="container">
      <div class="breadCrumbsContainer" style="display: flex;">
        支店編集 - {{name}}
        <div class="headerBtn" @click="branchList()" style="margin: 0px 0px 0px 20px;">一覧に戻る</div>
      </div>
      <!-- ローディング -->
      <div v-if="getLodingFlg || postLodingFlg">
        <vue-loading
          type="cylon"
          color="#1b7e47"
          :size="{ width: '150px', height: '150px' }"
        >
        </vue-loading>
        <div v-if="getLodingFlg" style="padding: 0px 0px 30px 0px;">Now loading...</div>
        <div v-if="postLodingFlg" style="padding: 0px 0px 30px 0px;">Now registering...</div>
      </div>
      <!-- 取得エラー表示 -->
      <div v-if="getErrorFlg" style="padding: 0px 0px 30px 0px; margin: auto;">
        <div　class="errMsg">
          <div class="errSpan" style="font-size:x-large;">
            {{errorMessage}}
          </div>
        </div>
      </div>
      <!-- 更新エラー表示 -->
      <div v-if="postErrorFlg" style="padding: 0px 0px 30px 0px; margin: auto;">
        <div　class="errMsg">
          <div class="errDiv">
            データの更新中に問題が発生しました。
          </div>
        </div>
      </div>
      <form name='addForm' v-if="!getLodingFlg && !getErrorFlg">
        <validation-observer ref="obs" v-slot="ObserverProps">
          <div class="group">
            <div class="groupTitle" style="display: flex;">
              基本情報【必須】
            </div>
            <div class="inputTitle" style="display: flex;">
              支店名
            </div>
            <div class="row">
              <validation-provider name="支店名" rules="required|max:255" mode="lazy">
                <div slot-scope="ProviderProps">
                  <input class="text large" v-model="detail.branchName"  style="width: 500px;" :placeholder="before.branchName">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
          </div>

          <div class="group">
            <div class="groupTitle" style="display: flex;">
              アカウント情報【必須】
            </div>
            <div class="inputTitle" style="display: flex;">
              メールアドレス
            </div>
            <div class="row">
              <validation-provider name="メールアドレス" rules="required|emailVaridate|max:255" mode="lazy">
                <div slot-scope="ProviderProps">
                  <input class="text large" v-model="detail.email"  style="width: 500px;" :placeholder="before.email">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="row">
              <div class="edit">パスワードを変更する場合、以下に新しいパスワードをご入力下さい。 変更しない場合、入力不要です。
              </div>
            </div>
            <div class="inputTitle" style="display: flex;">
              パスワード
            </div>
            <div class="row">
              <validation-provider name="パスワード" rules="half|min:8|max:64|password" vid="confirmation" mode="lazy">
                <div slot-scope="ProviderProps">
                  <input type="password" class="text large" v-model="detail.password"
                    style="width: 500px;" placeholder="ご希望のパスワード(8文字以上の半角英数記号)">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="inputTitle" style="display: flex;">
              パスワード確認
            </div>
            <div class="row">
              <validation-provider name="パスワード確認" rules="confirmed:confirmation|half|min:8|max:64" mode="lazy">
                <div slot-scope="ProviderProps">
                  <input type="password" class="text large" v-model="detail.confirm"
                   style="width: 500px;" placeholder="先ほど入力したパスワードを再度入力">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
          </div>

          <div class="buttonGroup">
            <button class="btn" @click="confirm" type = "button"
            v-bind:class="{ disabled:isProcessing() || ObserverProps.invalid || !ObserverProps.validate, active: !ObserverProps.invalid && ObserverProps.validate }"
            :disabled="ObserverProps.invalid">変更
            </button>
          </div>
        </validation-observer>
      </form>
    </div>
  </div>
</template>

<script lang='ts'>
import { Component, Vue } from 'vue-property-decorator';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required, email } from 'vee-validate/dist/rules';
import ApiClient from '../services/ApiClient';
import { VueLoading } from 'vue-loading-template';

export default {
  title: '支店編集',
  components: {
    ValidationProvider,
    ValidationObserver,
    VueLoading,
  },
  props: {
    id: {
      type: String,
      default: '0',
      required: true,
    },
    name: {
      type: String,
      default: '',
      required: true,
    },
  },
  data() {
    return {
      detail: {
        branchName: '',
        loginId: '',
        email: '',
        password: '',
        confirm: '',
        oldEmail: '',
      },
      before: {
        branchName: '',
        email: '',
      },
      // ローディング
      getLodingFlg: true,  // データ取得時ローディング用フラグ
      getErrorFlg: false,   // データ取得時エラーフラグ
      postLodingFlg: false, // データ更新時ローディングフラグ
      postErrorFlg: false,  // データ更新時エラーフラグ
      errorMessage: '',
    };
  },
  async mounted() {
    try {
      this.getLodingFlg = true;
      // 支店一意情報取得API呼出
      await this.setBranch(this.detail, this.id, this.before);
      // await new Promise((resolve) => setTimeout(resolve, 300));
    } catch (error) {
      this.errorMessage = error.message;
      this.getErrorFlg = true;
    } finally {
      this.getLodingFlg = false;
    }
  },
  computed: {
    role() {
      return this.$store.getters.session.role;
    },
    isSidebarShow() {
      return this.$store.getters.session.isSidebarShow;
    },
  },
  watch: {
    role() {
      this.$nextTick(() => {
        // 必要であれば処理を書く 現状必要なロジックはない
      });
    },
    isSidebarShow() {
      this.$nextTick(() => {
        // 必要であれば処理を書く 現状必要なロジックはない
      });
    },
  },
  methods: {
    // 支店一意情報取得API呼び出し
    setBranch(detail, id, before) {
      try {
        const restResourceService = new ApiClient();
        restResourceService.getBranch(id)
        .then((res) => {
          detail.branchName = res.branchName;
          detail.email = res.email;
          detail.oldEmail = detail.email;
          detail.loginId = res.loginId;
          //before
          before.branchName = res.branchName;
          before.email = res.email;
        });
      } catch (error) {
        this.errorMessage = error.message;
        this.getErrorFlg = true;
        throw error;
      }
    },
    // 変更ボタン押下時処理
    async confirm() {
      try {
        this.postErrorFlg = false;
        this.postLodingFlg = true;

        // cognitoPassword更新
        if (this.detail.password) {
          await this.$cognito.setUserPassword(this.detail.loginId, this.detail.email, this.detail.password);
        }

        // 支店更新API呼び出し
        const body = {
          id: this.id,
          branchName: this.detail.branchName,
          companyId: this.$store.getters.session.companyId,
          loginId: this.detail.loginId,
          email: this.detail.email,
        };
        const restResourceService = new ApiClient();
        await restResourceService.putBranch(body);
        if (this.detail.email != this.detail.oldEmail) {
          // メール送信API呼出
          // メールに使用するTemplateData
          const templateData = {
            oldEmail: this.detail.oldEmail,
            newEmail: this.detail.email,
          };
          await restResourceService.changeMail(this.detail.email, templateData);
        }
        // 登録完了
        history.back();
      } catch (error) {
        this.errorMessage = error.message;
        this.getErrorFlg = true;
        this.postErrorFlg = true;
        this.endProcessing();
      } finally {
        this.postLodingFlg = false;
        this.endProcessing();
      }
    },
    // 支店一覧に戻る
    branchList() {
      history.back();
    },
    // チャタリング防止
    startProcessing() {
      this.processing = true;
    },
    endProcessing() {
      this.processing = false;
    },
    isProcessing() {
      return this.processing;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../style/variables.scss";
.selectdiv {
  position: relative;
  float: left;
  min-width: 500px;
}

.selectdiv:after {
  content: '>';
  font: 17px "Consolas", monospace;
  color: #333;
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  transform: rotate(90deg);
  right: 11px;
  top: 18px;
  padding: 0 0 2px;
  border-bottom: 1px solid #999;
  position: absolute;
  pointer-events: none;
}

.selectdiv select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  /* Add some styling */

  display: block;
  width: 100%;
  max-width: 500px;
  height: 45px;
  float: right;
  margin: 5px 0px;
  padding: 0px 20px;
  font-size: 14.5px;
  line-height: 1.75;
  color: #333;
  background-color: #ffffff;
  background-image: none;
  border: 2px solid #000000;
  border-radius:10px;
  -ms-word-break: normal;
  word-break: normal;
}

</style>
